var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TweenOneGroup } from 'rc-tween-one';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Collapse from 'antd/lib/collapse';
import Radio from 'antd/lib/radio';
import Icon from './common/Icon';
var Panel = Collapse.Panel;
var RadioButton = Radio.Button;
var RadioGroup = Radio.Group;
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e, key) {
            var type = e.target.value;
            var value = _this.props.value;
            value[key] = type;
            _this.props.onChange('layout', value);
        };
        _this.getFlexChildToRender = function () {
            var _a = _this.props, locale = _a.locale, value = _a.value;
            var flexSelect = locale.flexSelect, flexName = locale.flexName;
            var getItemToChild = function (data, $key) {
                return Object.keys(data).map(function (key) { return (React.createElement(RadioButton, { value: key, key: key },
                    React.createElement(Icon, { type: $key + "-" + key, prompt: data[key] }))); });
            };
            var rowItem = Object.keys(flexSelect).map(function (key) {
                var item = flexSelect[key];
                var nameObj = flexName[key];
                return (React.createElement(Row, { gutter: 8, key: key },
                    React.createElement(Col, { span: 3 },
                        React.createElement(Icon, { type: nameObj.icon, prompt: nameObj.name })),
                    React.createElement(Col, { span: 21 },
                        React.createElement(RadioGroup, { value: value[key], size: "small", onChange: function (e) {
                                _this.onChange(e, key);
                            } }, getItemToChild(item, key)))));
            });
            return (React.createElement("div", { key: "flex", style: { overflow: 'hidden' } }, rowItem));
        };
        return _this;
    }
    Layout.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, locale = _a.locale, header = _a.header, props = __rest(_a, ["value", "locale", "header"]);
        var radioChildrenToRender = (React.createElement(RadioGroup, { value: value.display, size: "small", onChange: function (e) {
                _this.onChange(e, 'display');
            } }, Object.keys(locale.displaySelect).map(function (key) { return (React.createElement(RadioButton, { value: key, key: key },
            React.createElement(Icon, { type: key === 'none' ? 'eye-invisible' : key, prompt: locale.displaySelect[key] }))); })));
        var flexChild = value.display === 'flex' ? this.getFlexChildToRender() : null;
        return (React.createElement(Panel, __assign({}, props, { header: header || locale.header }),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, null, locale.name)),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, null, radioChildrenToRender)),
            React.createElement(TweenOneGroup, { enter: { height: 0, type: 'from', duration: 300, ease: 'easeInOutCirc' }, leave: { height: 0, duration: 300, ease: 'easeInOutCirc' }, style: { overflow: 'hidden' } }, flexChild)));
    };
    Layout.propTypes = {
        className: PropTypes.string,
        header: PropTypes.string,
        font: PropTypes.array,
        value: PropTypes.object,
        onChange: PropTypes.func,
        locale: PropTypes.object,
    };
    Layout.defaultProps = {
        className: 'editor-layout',
        value: {
            display: 'block',
            alignItems: 'stretch',
            justifyContent: 'flex-start',
        },
        onChange: function () {
        },
    };
    return Layout;
}(Component));
export default Layout;
Layout.componentName = 'EditorLayout';
